import { useEffect } from "react"
import { fetchPartnerTransaction, selectTransaction, selectTransactionLoading } from "../model"
import { Link, useParams } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { PageHeader } from "@/widgets/page-header"
import { PageSubtitle } from "@/shared/ui/page-subtitle"
import BonusSvg from '@/shared/assets/images/BonusMenuIcon.svg'
import { toLocaleDateTimeString } from "@/shared/lib/date-formatters"
import { Loader } from "@/shared/ui/loader"
import { NoTableData } from "@/shared/ui/no-table-data"

const clientTypes = {
    fiz: 'Физическое лицо',
    legal: 'Юридическое лицо'
}

export const PartnerTransactionPage = () => {
    const { id } = useParams()
    const transaction = useAppSelector(selectTransaction)
    const isLoading = useAppSelector(selectTransactionLoading)
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (id !== transaction?.id) {
            dispatch(fetchPartnerTransaction(id))
        }
    }, [id])
    
    return (
        <div className="_page_container">
            <PageHeader title="детали транзакции" />
            {transaction &&
                <div className='flexbox'>
                    <PageSubtitle
                        variant="acid"
                        title={
                            <div className="w-full flex items-center justify-between">
                                <div>
                                    Сумма транзакции
                                </div>
                                <div className="flex items-center gap-[6px] py-[6px] px-3 bg-color-acid rounded-full">
                                    <div className="text-color-dark font-manrope normal-case font-semibold">
                                        {transaction.bonusTotal}
                                    </div>
                                    <div className="fill-color-acid text-color-dark">
                                        <BonusSvg width={24} height={24} />
                                    </div>
                                </div>
                            </div>
                        }
                    />
                    <div className="box">
                        <div className="box_header !mb-4 screen:!mb-[22px] font-mediumttf">
                            детали транзакции
                        </div>
                        <div className="flex flex-col">
                            <div className="pb-[10px] border-b mb-3 border-[#B9C9C6]">
                                <div className="text-[#828282] text-[12px] mb-2 uppercase">Номер транзакции</div>
                                <div className="text-[13px] text-color-dark">
                                    {transaction.id}
                                </div>
                            </div>
                            <div className="pb-[10px] border-b mb-3 border-[#B9C9C6]">
                                <div className="text-[#828282] text-[12px] mb-2 uppercase">Дата операции</div>
                                <div className="text-[13px] text-color-dark">
                                    {toLocaleDateTimeString(transaction.timeStamp)}
                                </div>
                            </div>
                            <div className="pb-[10px] border-b mb-3 border-[#B9C9C6]">
                                <div className="text-[#828282] text-[12px] mb-2 uppercase">Тип операции</div>
                                <div className="text-[13px] text-color-dark">
                                    Списание
                                </div>
                            </div>
                            <div className="pb-[10px] border-b mb-3 border-[#B9C9C6]">
                                <div className="text-[#828282] text-[12px] mb-2 uppercase">Тип клиента</div>
                                <div className="text-[13px] text-color-dark">
                                    {clientTypes[transaction.clientType]}
                                </div>
                            </div>
                            <div className="pb-[10px] border-b mb-3 border-[#B9C9C6]">
                                <div className="text-[#828282] text-[12px] mb-2 uppercase">Клиент</div>
                                <div className="text-[13px] text-color-dark">
                                    {transaction.clientName?.trim() ? transaction.clientName : "—"}
                                </div>
                            </div>
                            <div className="pb-[10px] border-b mb-3 border-[#B9C9C6]">
                                <div className="text-[#828282] text-[12px] mb-2 uppercase">ИНН / Telegram Id</div>
                                <div className="text-[13px] text-color-dark">
                                    {transaction.clientType === 'legal'
                                        ? transaction.clientInfo || "—"
                                        : transaction.clientInfo
                                            ? <Link to={`/users/profile/${transaction.clientId}`} className="text-color-primary hover:underline cursor-pointer">
                                                { transaction.clientInfo }
                                            </Link>
                                            : "—"
                                    }
                                </div>
                            </div>
                            {Boolean(transaction.accruals?.length) && (
                                <div className="pb-[10px] border-b mb-3 border-[#B9C9C6]">
                                    <div className="text-[#828282] text-[12px] mb-2 uppercase">Правила начисления</div>
                                    <div className="flex flex-col gap-2 text-[13px] text-color-dark">
                                        {transaction.accruals?.map(accrual => (
                                            <div key={accrual.partner_accrual_id + accrual.bonus_id}>
                                                <div>{accrual.partner_accrual_name || "—"}</div>
                                                <div className="text-[#828282]">{accrual.partner_accrual_id}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="box">
                        <div className="box_header !mb-4 screen:!mb-[22px] font-mediumttf">
                            Электронный чек
                        </div>
                        <table className='w-full'>
                            <thead>
                                <tr className="text-[#828282] text-[13px] uppercase font-semibold font-manrope">
                                    <th className="border-b border-[#E7EAEE] !text-start px-2 py-5">Кол-во</th>
                                    <th className='border-b border-[#E7EAEE] !text-start px-2 py-5'>Название</th>
                                    <th className='border-b border-[#E7EAEE] !text-start px-2 py-5'>Цена</th>
                                    <th className='border-b border-[#E7EAEE] !text-start px-2 py-5'>Скидка</th>
                                    <th className='border-b border-[#E7EAEE] !text-start px-2 py-5'>Бонусная скидка</th>
                                    <th className='border-b border-[#E7EAEE] !text-start px-2 py-5'>НДС, руб.</th>
                                    <th className='border-b border-[#E7EAEE] !text-start px-2 py-5'>ИТОГО, руб.</th>
                                    <th className='border-b border-[#E7EAEE] !text-start px-2 py-5'>НДС</th>
                                </tr>
                            </thead>
                            <tbody>
                                {transaction.paymentItems.map((item, index) =>
                                    <tr key={index}>
                                        <td className='text-nowrap h-full px-2 py-5 text-[13px] font-manrope font-semibold text-color-dark border-[#E7EAEE] border-b w-auto'>
                                            {item.quantity} {item.measure}.
                                        </td>
                                        <td className="text-nowrap h-full px-2 py-5 text-[13px] font-manrope font-semibold text-color-dark border-[#E7EAEE] border-b w-auto">
                                            <div className='inline-block overflow-hidden text-ellipsis w-full pr-2 text-nowrap'>
                                                {item.name}
                                            </div>
                                        </td>
                                        <td className='text-nowrap h-full px-2 py-5 text-[13px] font-manrope font-semibold text-color-dark border-[#E7EAEE] border-b w-auto'>
                                            {item.price}
                                        </td>
                                        <td className='text-nowrap h-full px-2 py-5 text-[13px] font-manrope font-semibold text-color-dark border-[#E7EAEE] border-b w-auto'>
                                            {item.discountAmount}
                                        </td>
                                        <td className='text-nowrap h-full px-2 py-5 text-[13px] font-manrope font-semibold text-color-dark border-[#E7EAEE] border-b w-auto'>
                                            {item.bonus}
                                        </td>
                                        <td className='text-nowrap h-full px-2 py-5 text-[13px] font-manrope font-semibold text-color-dark border-[#E7EAEE] border-b w-auto'>
                                            {item.taxAmount}
                                        </td>
                                        <td className='text-nowrap h-full px-2 py-5 text-[13px] font-manrope font-semibold text-color-dark border-[#E7EAEE] border-b w-auto'>
                                            {item.amount}
                                        </td>
                                        <td className='text-nowrap h-full px-2 py-5 text-[13px] font-manrope font-semibold text-color-dark border-[#E7EAEE] border-b w-auto'>
                                            {item.tax}%
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                            <tr className='border-t border-b'>
                                <td className='text-nowrap h-full px-2 py-5 text-[13px] font-manrope font-semibold text-color-dark border-[#E7EAEE] border-b w-auto'>ИТОГ</td>
                                <td className="text-nowrap h-full px-2 py-5 text-[13px] font-manrope font-semibold text-color-dark border-[#E7EAEE] border-b w-auto"></td>
                                <td className="text-nowrap h-full px-2 py-5 text-[13px] font-manrope font-semibold text-color-dark border-[#E7EAEE] border-b w-auto"></td>
                                <td className="text-nowrap h-full px-2 py-5 text-[13px] font-manrope font-semibold text-color-dark border-[#E7EAEE] border-b w-auto">{transaction.discountTotal}</td>
                                <td className="text-nowrap h-full px-2 py-5 text-[13px] font-manrope font-semibold text-color-dark border-[#E7EAEE] border-b w-auto">{transaction.bonusTotal}</td>
                                <td className="text-nowrap h-full px-2 py-5 text-[13px] font-manrope font-semibold text-color-dark border-[#E7EAEE] border-b w-auto">{transaction.taxTotal}</td>
                                <td className="text-nowrap h-full px-2 py-5 text-[13px] font-manrope font-semibold text-color-dark border-[#E7EAEE] border-b w-auto">{transaction.total}</td>
                                <td className="text-nowrap h-full px-2 py-5 text-[13px] font-manrope font-semibold text-color-dark border-[#E7EAEE] border-b w-auto"></td>
                            </tr>
                        </table>
                        <div className='grid grid-cols-12 mt-4 gap-y-4'>
                            <div className='col-span-6 md:col-span-3 font-bold'>
                                ФН ККТ
                            </div>
                            <div className='col-span-6 md:col-span-3'>
                                {transaction.fnSerialNumber}
                            </div>
                            <div className='col-span-6 md:col-span-3 font-bold'>
                                ФП ККТ
                            </div>
                            <div className='col-span-6 md:col-span-3'>
                                {transaction.fiscalSign}
                            </div>
                            <div className='col-span-6 md:col-span-3 font-bold'>
                                ФД ККТ
                            </div>
                            <div className='col-span-6 md:col-span-9'>
                                {transaction.documentNumber}
                            </div>
                            <div className='col-span-6 md:col-span-3 font-bold'>
                                RRN
                            </div>
                            <div className='col-span-6 md:col-span-3'>
                                {transaction.rrn}
                            </div>
                            <div className='col-span-6 md:col-span-3 font-bold'>
                                M
                            </div>
                            <div className='col-span-6 md:col-span-3'>
                                {transaction.merchantId}
                            </div>
                            <div className='col-span-6 md:col-span-3 font-bold'>
                                T
                            </div>
                            <div className='col-span-6 md:col-span-9'>
                                {transaction.terminalId}
                            </div>
                        </div>
                    </div>
                </div>
            }
            {(!transaction && isLoading) &&
                <div className="info_panel">
                    <Loader />
                </div>
            }
            {(!transaction && !isLoading) &&
                <NoTableData label="Нет данных о транзакции"/>
            }
        </div>
    )
}
